import ChangePassword from "./Views/Pages/Auth/ChangePassword";
import ForgotPassword from "./Views/Pages/Auth/ForgotPassword";
import Login from "./Views/Pages/Auth/Login";
import Signup from "./Views/Pages/Auth/Signup";
import ChooseProduct from "./Views/Pages/GetStarted/ChooseProduct";
import ChoosePlatform from "./Views/Pages/GetStarted/ChoosePlatform";
import CollectMagento from "./Views/Pages/GetStarted/CollectMagento";
import CollectAiAssistantMagento from "./Views/Pages/GetStarted/CollectAiAssistantMagento";
import AiAssistantMagentoSettings from "./Views/Pages/GetStarted/AiAssistantMagentoSettings";
import CollectCmsAssistant from "./Views/Pages/GetStarted/CollectCmsAssistant";
import CmsAssistantMessengerSettings from "./Views/Pages/GetStarted/CmsAssistantMessengerSettings";
import CmsAssistantComplete from "./Views/Pages/GetStarted/CmsAssistantComplete";
import CollectWooCommerce from "./Views/Pages/GetStarted/CollectWooCommerce";
import CollectDrupal from "./Views/Pages/GetStarted/CollectDrupal";
import CollectCustomSites from "./Views/Pages/GetStarted/CollectCustomSites";
import CustomPlatformSettings from "./Views/Pages/GetStarted/CustomPlatformSettings";
import NoResult from "./Views/Pages/Search/Reports/NoResult";
import ProductsClicked from "./Views/Pages/Search/Reports/ProductsClicked";
import ProductsShown from "./Views/Pages/Search/Reports/ProductsShown";
import AdminDashboardComparison from "./Views/Pages/Search/AdminDashboardComparison";
import AdminSettings from "./Views/Pages/Admin/AdminSettings";
import UserActivityLog from "./Views/Pages/Admin/UserActivityLog";
import AiAssistantDashboardComparison from "./Views/Pages/Search/AiAssistantDashboardComparison";
import SearchTerms from "./Views/Pages/Search/Reports/SearchTerms";
import Dashboard from "./Views/Pages/User/Dashboard";
import Settings from "./Views/Pages/User/Settings";
import AddAccountChooseProduct from "./Views/Pages/User/Add_Account/ChooseProduct";
import AddAccountChoosePlatform from "./Views/Pages/User/Add_Account/ChoosePlatform";
import AddAccountCollectMagento from "./Views/Pages/User/Add_Account/CollectMagento";
import AddAccountCollectWooCommerce from "./Views/Pages/User/Add_Account/CollectWooCommerce";
import AddAccountCollectCustomSites from "./Views/Pages/User/Add_Account/CollectCustomSites";
import AddAccountCollectAiAssistantMagento from "./Views/Pages/User/Add_Account/CollectAiAssistantMagento";
import AddAccountAiAssistantMagentoSettings from "./Views/Pages/User/Add_Account/AiAssistantMagentoSettings";
import AddAccountCustomPlatformSettings from "./Views/Pages/User/Add_Account/CustomPlatformSettings";
import Merchandising from "./Views/Pages/Search/Merchandising/Index";
import Categories from "./Views/Pages/Search/Merchandising/Categories";
import Search from "./Views/Pages/Search/Merchandising/Search";
import LandingPage from "./Views/Pages/Search/Merchandising/LandingPage";
import Banners from "./Views/Pages/Search/Merchandising/Banners";
import PromoTiles from "./Views/Pages/Search/Merchandising/PromoTiles";
import EditCategory from "./Views/Pages/Search/Merchandising/EditCategory";
import EditSearch from "./Views/Pages/Search/Merchandising/EditSearch";
import AutoComplete from "./Views/Pages/Search/SearchOptions/AutoComplete";
import InstantSearch from "./Views/Pages/Search/SearchOptions/InstantSearch";
import EditLandingPage from "./Views/Pages/Search/Merchandising/EditLandingPage";
import Category from "./Views/Pages/Search/SearchOptions/Category";
import RevenueImpact from "./Views/Pages/Search/Reports/RevenueImpact";
import AutoCompleteDesign from "./Views/Pages/Search/Design/AutoComplete";
import InstantSearchDesign from "./Views/Pages/Search/Design/InstantSearch";
import DynamicBundling from "./Views/Pages/Upsell/Bundling/DynamicBundling";
// import ColorFamilies from "./Views/Pages/Filters/ColorFamilies";
// import FiltersList from "./Views/Pages/Filters/FiltersList";
import SynonymsList from "./Views/Pages/Synonyms/SynonymsList";
import DrupalComplete from "./Views/Pages/GetStarted/DrupalComplete";
import AutocompleteSettings from "./Views/Pages/Drupal/AutocompleteSettings";
import SearchResultSettings from "./Views/Pages/Drupal/SearchResultSettings";
import DesignSettings from "./Views/Pages/Drupal/DesignSettings";
import DisplayFieldMapping from "./Views/Pages/Drupal/DisplayFieldMapping";
import CustomRanking from "./Views/Pages/Drupal/CustomRanking";
// AI Assistant Components
import AIAssistantDashboard from "./Views/Pages/AIAssistant/AIAssistantDashboard";
import AIAssistantProducts from "./Views/Pages/AIAssistant/AIAssistantProducts";
import AIAssistantQuestions from "./Views/Pages/AIAssistant/AIAssistantQuestions";
import AIAssistantResponses from "./Views/Pages/AIAssistant/AIAssistantResponses";
import AIAssistantTraining from "./Views/Pages/AIAssistant/AIAssistantTraining";
// import AIAssistantTrainingList from "./Views/Pages/AIAssistant/AIAssistantTrainingList";
import AIAssistantIntegration from "./Views/Pages/AIAssistant/AIAssistantIntegration";
import AIAssistantSettings from "./Views/Pages/AIAssistant/AIAssistantSettings";
import QuestionForm from "./Views/Pages/AIAssistant/QuestionForm";
import ColorFamilies from "./Views/Pages/Search/Filters/ColorFamilies";
import FiltersList from "./Views/Pages/Search/Filters/FiltersList";
import AddFilter from "./Views/Pages/Search/Filters/AddFilter";
import EditFilter from "./Views/Pages/Search/Filters/EditFilter";
import TopPerformingProducts from "./Views/Pages/Search/Reports/TopPerformingProducts";
import LowPerformingProducts from "./Views/Pages/Search/Reports/LowPerformingProducts";
import AlmostBuyProducts from "./Views/Pages/Search/Reports/AlmostBuyProducts";
import ZeroResultQueries from "./Views/Pages/Search/Reports/ZeroResultQueries";
import LowProductPageViewQueries from "./Views/Pages/Search/Reports/LowProductPageViewQueries";
import HighIntentLowConversionQueries from "./Views/Pages/Search/Reports/HighIntentLowConversionQueries";
// import Category from "./Views/Pages/Search/SearchOptions/Category";
import Rules from "./Views/Pages/Search/Merchandising/Rules.jsx";
import RuleEditor from "./Views/Pages/Search/Merchandising/RuleEditor.jsx";
import KeywordProducts from "./Views/Pages/Search/Reports/KeywordProducts";
import ProductKeywords from "./Views/Pages/Search/Reports/ProductKeywords";
// CMS Assistant Components
import CmsAssistantDashboard from "./Views/Pages/CmsAssistant/Dashboard";
import CmsAssistantContentSearch from "./Views/Pages/CmsAssistant/ContentSearch";
import MessengerSettings from "./Views/Pages/CmsAssistant/MessengerSettings";
import SearchDashboard from "./Views/Pages/Search/Dashboard";

export const authRoutes = [
  {
    path: "/login",
    name: "Login",
    component: <Login />,
    layout: "/auth",
  },
];

export const getStartedRoutes = [
  {
    path: "/chooseProduct",
    name: "Choose Product",
    component: <ChooseProduct />,
    layout: "/getStarted",
  },
  {
    path: "/choosePlatform",
    name: "Choose Platform",
    component: <ChoosePlatform />,
    layout: "/getStarted",
  },
  {
    path: "/magento",
    name: "Magento",
    component: <CollectMagento />,
    layout: "/getStarted",
  },
  {
    path: "/woocommerce",
    name: "WooCommerce",
    component: <CollectWooCommerce />,
    layout: "/getStarted",
  },
  {
    path: "/drupal",
    name: "Drupal",
    component: <CollectDrupal />,
    layout: "/getStarted",
  },
  {
    path: "/custom",
    name: "Custom Sites",
    component: <CollectCustomSites />,
    layout: "/getStarted",
  },
  {
    path: "/aiAssistantMagento",
    name: "AI Assistant Magento",
    component: <CollectAiAssistantMagento />,
    layout: "/getStarted",
  },
  {
    path: "/aiAssistantMagentoSettings",
    name: "AI Assistant Magento Settings",
    component: <AiAssistantMagentoSettings />,
    layout: "/getStarted",
  },
  {
    path: "/customPlatformSettings",
    name: "Custom Platform Settings",
    component: <CustomPlatformSettings />,
    layout: "/getStarted",
  },
  {
    path: "/cmsAssistant",
    name: "CMS Assistant",
    component: <CollectCmsAssistant />,
    layout: "/getStarted",
  },
  {
    path: "/cmsAssistantSettings",
    name: "CMS Assistant Settings",
    component: <CmsAssistantMessengerSettings />,
    layout: "/getStarted",
  },
  {
    path: "/cmsAssistantComplete",
    name: "CMS Assistant Complete",
    component: <CmsAssistantComplete />,
    layout: "/getStarted",
  },
  {
    path: "/drupalApiKey",
    name: "Drupal API Key",
    component: <DrupalComplete />,
    layout: "/getStarted",
  },
];

export const userRoutes = [
  {
    path: "/admin-dashboard",
    name: "Admin Dashboard",
    component: <AdminDashboardComparison />,
    menuSvg: `<svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" class="stl-text-grey-400 stl-ml-[-3px] stl-shrink-0"><path d="M64.6 36V32C64.6 22.3 57.7 15.4 48 15.4H32C22.3 15.4 15.4 22.3 15.4 32C15.4 41.7 22.3 48.6 32 48.6H40" stroke="currentColor" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M61.9 58.8C63.2 57.5 64 55.7 64 54C64 50.7 61.3 48 58 48C54.7 48 52 50.7 52 54C52 57.3 54.7 60 58 60C59.8 60 61.6 59.2 62.9 57.9L67 62" stroke="currentColor" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`,
    layout: "/search",
    type: "mainMenu",
    productType: "search",
  },
  {
    path: "/admin-dashboard",
    name: "AI Assistant",
    component: <AiAssistantDashboardComparison />,
    menuSvg: `<i class="fas fa-microchip stl-text-grey-400 stl-shrink-0" style="font-size: 18px; margin-left: 1px; margin-top:5px"></i>`,
    layout: "/aiassistant",
    type: "mainMenu",
  },
  {
		path: "/user-activity",
		name: "User Activity Log",
    menuSvg:`<i class="fa fa-history stl-text-grey-400 stl-shrink-0" style="font-size: 18px; margin-left: 1px; margin-top:5px"></i>`,
		layout: "/search",
		type: "mainMenu",
	},
  {
    path: "/settings",
    name: "Account Settings",
    layout: "/search",
    menuSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-settings stl-text-grey-400 stl-ml-[-3px] stl-shrink-0"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>`,
    type: "bottomMenu",
  },
];

export const UpsellRoutes = [
  {
    name: "Dynamic Bundling",
    fontIcon: "fa-cube",
    layout: "/upsell",
    type: "upsellMenu",
    subMenu: [
      {
        path: "/dynamic",
        name: "Bundling",
        layout: "/upsell",
        menuFlag: true,
        component: <DynamicBundling />,
      },
    ],
  },
];

export const AIAssistantRoutes = [
  {
    name: "AI Shopping",
    fontIcon: "fa-robot",
    layout: "/aiassistant",
    type: "aiMenu",
    subMenu: [
      {
        path: "/dashboard",
        name: "Dashboard",
        layout: "/aiassistant",
        menuFlag: true,
        component: <AIAssistantDashboard />,
      },
      // {
      // 	path: "/products",
      // 	name: "Products",
      // 	layout: "/aiassistant",
      // 	menuFlag: true,
      // 	component: <AIAssistantProducts />,
      // },
      // {
      //   path: "/questions",
      //   name: "Questions",
      //   layout: "/aiassistant",
      //   menuFlag: true,
      //   component: <AIAssistantQuestions />,
      // },
      // {
      //   path: "/questions/add",
      //   name: "Add Question",
      //   layout: "/aiassistant",
      //   menuFlag: false,
      //   component: <QuestionForm />,
      // },
      // {
      //   path: "/questions/edit",
      //   name: "Edit Question",
      //   layout: "/aiassistant",
      //   menuFlag: false,
      //   component: <QuestionForm />,
      // },
      {
        path: "/responses",
        name: "Responses",
        layout: "/aiassistant",
        menuFlag: true,
        component: <AIAssistantResponses />,
      },
      // {
      // 	path: "/training",
      // 	name: "Training",
      // 	layout: "/aiassistant",
      // 	menuFlag: true,
      // 	component: <AIAssistantTrainingList />,
      // },
      {
        path: "/training/add",
        name: "Add Training",
        layout: "/aiassistant",
        menuFlag: false,
        component: <AIAssistantTraining />,
      },
      {
        path: "/training/edit/:trainingId",
        name: "Edit Training",
        layout: "/aiassistant",
        menuFlag: false,
        component: <AIAssistantTraining />,
      },
      // {
      // 	path: "/integrations",
      // 	name: "Integrations",
      // 	layout: "/aiassistant",
      // 	menuFlag: true,
      // 	component: <AIAssistantIntegration />,
      // },
      // {
      // 	path: "/settings",
      // 	name: "Settings",
      // 	layout: "/aiassistant",
      // 	menuFlag: true,
      // 	component: <AIAssistantSettings />,
      // },
    ],
  },
];

export const SearchRoutes = [
  {
    path: "/admin-dashboard",
    name: "Admin Dashboard",
    component: <AdminDashboardComparison />,
    fontIcon: "fa-chart-pie",
    layout: "/search",
    type: "searchMenu",
    hideInSidebar: true,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: <SearchDashboard />,
    fontIcon: "fa-desktop",
    layout: "/search",
    type: "searchMenu",
  },
  {
    path: "/settings",
    name: "Account Settings",
    component: <AdminSettings />,
    fontIcon: "fa-gear",
    layout: "/search",
    type: "searchMenu",
    hideInSidebar: true,
  },
  {
    path: "/user-activity",
    name: "User Activity Log",
    component: <UserActivityLog />,
    fontIcon: "fa-history",
    layout: "/search",
    type: "searchMenu",
    hideInSidebar: true,
  },
  {
    name: "Reports",
    fontIcon: "fa-chart-line",
    layout: "/search",
    type: "searchMenu",
    subMenu: [
      {
        path: "/reports/searchTerms",
        name: "Search Terms",
        layout: "/search",
        menuFlag: true,
        component: <SearchTerms />,
        availablePlatforms: ["magento"],
      },
      {
        path: "/reports/noResults",
        name: "No Results",
        layout: "/search",
        menuFlag: true,
        component: <NoResult />,
        availablePlatforms: ["magento"],
      },
      {
        path: "/reports/productsShown",
        name: "Products Shown",
        layout: "/search",
        menuFlag: true,
        component: <ProductsShown />,
        availablePlatforms: ["magento"],
      },
      {
        path: "/reports/productsClicked",
        name: "Products Clicked",
        layout: "/search",
        menuFlag: true,
        component: <ProductsClicked />,
        availablePlatforms: ["magento"],
      },
      {
        path: "/reports/revenueImpact",
        name: "Revenue Impact",
        layout: "/search",
        menuFlag: true,
        component: <RevenueImpact />,
        availablePlatforms: ["bigcommerce", "shopify", "woocommerce"],
      },
      {
        path: "/reports/productKeywords",
        name: "Product Keyword Performance",
        layout: "/search",
        menuFlag: true,
        component: <ProductKeywords />,
        availablePlatforms: ["bigcommerce", "shopify", "woocommerce"],
      },
      {
        path: "/reports/keywordProducts",
        name: "Keyword Product Performance",
        layout: "/search",
        menuFlag: true,
        component: <KeywordProducts />,
        availablePlatforms: ["bigcommerce", "shopify", "woocommerce"],
      },
      {
        path: "/reports/topPerforming",
        name: "Top Performing Products",
        layout: "/search",
        menuFlag: true,
        component: <TopPerformingProducts />,
        availablePlatforms: ["bigcommerce", "shopify", "woocommerce"],
      },
      {
        path: "/reports/lowPerforming",
        name: "Low Performing Products",
        layout: "/search",
        menuFlag: true,
        component: <LowPerformingProducts />,
        availablePlatforms: ["bigcommerce", "shopify", "woocommerce"],
      },
      {
        path: "/reports/almostBuy",
        name: "Almost Buy Products",
        layout: "/search",
        menuFlag: true,
        component: <AlmostBuyProducts />,
        availablePlatforms: ["bigcommerce", "shopify", "woocommerce"],
      },
      {
        path: "/reports/zeroResultQueries",
        name: "Zero-Result Queries Report",
        layout: "/search",
        menuFlag: true,
        component: <ZeroResultQueries />,
        availablePlatforms: ["bigcommerce", "shopify", "woocommerce"],
      },
      {
        path: "/reports/lowProductPageViewQueries",
        name: "Low-Product Page View Queries",
        layout: "/search",
        menuFlag: true,
        component: <LowProductPageViewQueries />,
        availablePlatforms: ["bigcommerce", "shopify", "woocommerce"],
      },
      {
        path: "/reports/highIntentLowConversionQueries",
        name: "High-Intent Queries With Low Conversion",
        layout: "/search",
        menuFlag: true,
        component: <HighIntentLowConversionQueries />,
        availablePlatforms: ["bigcommerce", "shopify", "woocommerce"],
      },
    ],
  },
];

export const CmsAssistantRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: <CmsAssistantDashboard />,
    fontIcon: "fa-desktop",
    layout: "/cmsassistant",
    type: "cmsMenu",
  },
  {
    path: "/content",
    name: "Content",
    component: <CmsAssistantContentSearch />,
    fontIcon: "fa-search",
    layout: "/cmsassistant",
    type: "cmsMenu",
  },
  {
    path: "/messengerSettings",
    name: "Messenger Settings",
    component: <MessengerSettings />,
    fontIcon: "fa-comments",
    layout: "/cmsassistant",
    type: "cmsMenu",
  },
];
